import { GetCountriesListModel } from "@services/models/Common/GetCountriesList";
import { GetCountryStatesResponse } from "@services/models/Common/GetCountryStates";
import {
  GetRegionListRequest,
  GetRegionListResponse,
} from "@services/models/Common/GetRegionList";
import { UploadImageResponse } from "@services/models/Common/UploadImage";
import { createApiClient } from "../api/createApiClient";
import { AxiosInstance } from "axios";

class CommonApiService {
  private api: AxiosInstance;
  constructor() {
    this.api = createApiClient();
  }

  public async getCountriesList(): Promise<GetCountriesListModel> {
    try {
      const response = await this.api.get("/common/getCountriesList");
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async getRegionList(
    data: GetRegionListRequest
  ): Promise<GetRegionListResponse> {
    try {
      const params: Record<string, any> = {};
      params.countryCode = data.countryCode;
      const response = await this.api.get("/common/getRegionsList", {
        params: params,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async getCountryStates(
    country: string
  ): Promise<GetCountryStatesResponse> {
    try {
      const response = await this.api.get<GetCountryStatesResponse>(
        "/adminPanel/countryStates",
        {
          params: { country },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async uploadImage(file: File): Promise<UploadImageResponse> {
    try {
      const formData = new FormData();
      formData.append("image", file);

      const response = await this.api.post<UploadImageResponse>(
        "/common/uploadImage",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async uploadKycImage(
    file: File,
    userId: string,
    fileName: string
  ): Promise<UploadImageResponse> {
    try {
      const formData = new FormData();
      formData.append("image", file);
      formData.append("fieldName", fileName);
      formData.append("userId", userId);

      const response = await this.api.post<UploadImageResponse>(
        "/common/uploadKYCImage",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async uploadFile(
    file: File,
    fileId: string | number
  ): Promise<UploadImageResponse> {
    try {
      if (fileId === undefined || fileId === null) {
        throw new Error(
          "FileId parameter is required for unauthenticated uploads"
        );
      }

      const formData = new FormData();
      formData.append("file", file);
      formData.append("fileId", String(fileId));

      const response = await this.api.post<UploadImageResponse>(
        "/common/openUploadFile",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const commonApiServices = new CommonApiService();
